module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('section', {
    staticClass: "mainProduct"
  }, [_c('div', {
    staticClass: "container_flex mainProduct__container"
  }, [(_vm.pageSize !== 'L') ? _c('mainHeader', {
    attrs: {
      "pathHeader": _vm.products[_vm.mainProduct].header,
      "pathTail": _vm.products[_vm.mainProduct].headerTail,
      "pageSize": _vm.pageSize
    }
  }) : _vm._e(), _vm._v(" "), _c('mainImg', {
    attrs: {
      "pathImg": _vm.products[_vm.mainProduct].img,
      "alt": _vm.products[_vm.mainProduct].header,
      "social": _vm.social,
      "showOverlay": _vm.showOverlay,
      "pageSize": _vm.pageSize
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mainProduct__info"
  }, [(_vm.pageSize === 'L') ? _c('mainHeader', {
    attrs: {
      "pathHeader": _vm.products[_vm.mainProduct].header,
      "pathTail": _vm.products[_vm.mainProduct].headerTail,
      "pageSize": _vm.pageSize
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "mainProduct__item"
  }, [_vm._v("\n          Item #: \n          "), _c('span', {
    staticClass: "mainProduct__id"
  }, [_vm._v("\n            " + _vm._s(_vm.products[_vm.mainProduct].id) + "\n          ")])]), _vm._v(" "), _c('mainPrice', {
    attrs: {
      "pathProduct": _vm.products[_vm.mainProduct]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mainProduct__starsAndShareWrap"
  }, [_c('starsList', {
    attrs: {
      "setStar": _vm.setStar,
      "estimateProduct": _vm.estimateProduct,
      "pathProduct": _vm.products[_vm.mainProduct]
    }
  }), _vm._v(" "), _c('mainShare', {
    attrs: {
      "shareIsVisiable": _vm.shareIsVisiable,
      "social": _vm.social,
      "hideShare": _vm.hideShare,
      "showShare": _vm.showShare,
      "pageSize": _vm.pageSize
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mainProduct__aboutWrap"
  }, [_c('h5', {
    staticClass: "mainProduct__blockHeader"
  }, [_vm._v(_vm._s(_vm.aboutHeader))]), _vm._v(" "), _c('p', {
    staticClass: "mainProduct__about"
  }, [_vm._v("\n            " + _vm._s(_vm.products[_vm.mainProduct].about) + "\n          ")])]), _vm._v(" "), _c('size', {
    attrs: {
      "pathSize": _vm.products[_vm.mainProduct].size,
      "chooseSize": _vm.chooseSize,
      "sizeHeader": _vm.sizeHeader
    }
  }), _vm._v(" "), _c('mainBtn', {
    attrs: {
      "addToCard": _vm.addToCard
    }
  })], 1)], 1)]), _vm._v(" "), _c('grid', {
    attrs: {
      "makeItomMain": _vm.makeItomMain,
      "mainProduct": _vm.mainProduct,
      "sliderControl": _vm.sliderControl,
      "pageSize": _vm.pageSize,
      "products": _vm.products
    }
  }), _vm._v(" "), _c('overlay', {
    attrs: {
      "pathImg": _vm.products[_vm.mainProduct].img,
      "overlayShow": _vm.overlayShow,
      "hideOverlay": _vm.hideOverlay
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fc35923","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainProduct.vue
// module id = 56
// module chunks = 0